module.exports = __webpack_public_path__ + "static/media/step3.9168ac85.png";